import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import CustomNavigationBar from "@components/CustomNotificationBar";
import "./release-date.scss";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// import DatePicker from "react-date-picker";
import { getValue } from "@utils/lodash";
import SearchHeader from "@components/common/SearchHeader";
import {
  CreateCheckpointReleaseDate,
  GetCheckpointReleaseDate,
  ReleaseDateAuditCompleted,
} from "@services/checkpoint.service";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import { toast } from "react-toastify";
import InputField from "@_common/InputRuleFeild";
import PaginationPage from "@components/pagination/pagination";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import CalenderDropdown from "@_common/CalenderDropdown";
import DeleteModal from "@_common/deleteModal";
import ConfirmModal from "@_common/ConfirmModal";
import { NavLink } from "react-router-dom";
import MenuRepositorySvgComponent from "../../../assets/svg-components/left-menu/menurepo";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import CheckpointReleaseDatesNotfound from "@components/Page-Not-Found/checkpoint-release-dates-not-found";

export default function ReleaseDates(props: any) {
  const navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [list, setList] = React.useState<any>([]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      setDate(new Date());
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      // status: "active",
      sort_by: params.sort_by,
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await GetCheckpointReleaseDate(queryRequest);
      if (resp) {
        let list = getValue(resp, `data.vendors`, []).map((item: object) => ({
          ...item,
          start_date: "",
          cutoff_date: "",
        }));
        let array: [] | any = [];
        let a =
          getValue(list, `length`, 0) > 0
            ? list.filter((item: object) => {
                if (
                  !getValue(item, `release_date.start_date`, "") &&
                  !getValue(item, `release_date.cutoff_date`, "")
                ) {
                  return array.push({
                    // ...item,
                    vendor_id: getValue(item, `id`, ""),
                    main_id: getValue(item, `id`, ""),
                    start_date: "",
                    cutoff_date: "",
                    vendor_name: getValue(item, `vendor_name`, ""),
                    is_extension: false,
                    is_audit_completed: getValue(
                      item,
                      `release_date.is_audit_completed`,
                      false
                    ),
                  });
                } else {
                  return array.push({
                    // ...item,
                    main_id: getValue(item, `id`, ""),
                    start_date: getValue(item, `release_date.start_date`, ""),
                    cutoff_date: getValue(item, `release_date.cutoff_date`, ""),
                    id: getValue(item, `release_date.id`, ""),
                    vendor_id: getValue(item, `release_date.vendor.id`, ""),
                    vendor_name: getValue(item, `vendor_name`, ""),
                    is_extension: false,
                    is_audit_completed: getValue(
                      item,
                      `release_date.is_audit_completed`,
                      false
                    ),
                  });
                }
              })
            : [];
        setList(array);
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let month = params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM");
    let year = params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY");
    try {
      const payload = list.filter((f: object) =>
        selectedIndex.some((d: string) => d == getValue(f, `main_id`, ""))
      );

      let payloadObj = JSON.parse(JSON.stringify(payload));
      let main = payloadObj.map((item: object) => ({
        start_date: getValue(item, `start_date`, ""),
        cutoff_date: getValue(item, `cutoff_date`, ""),
        vendor_id: getValue(item, `vendor_id`, ""),
        is_extension: getValue(item, `is_extension`, false),
        // vendor_name: getValue(item, `vendor_name`, ""),
        id: getValue(item, `id`, ""),
      }));

      main.filter((item: any) => {
        if (!getValue(item, `id`, "")) {
          delete item.id;
        }
      });
      let submit = true;

      for (let i = 0; i < main.length; i++) {
        if (!main[i].cutoff_date || !main[i].start_date) {
          submit = false;
          break;
        }
      }
      if (submit) {
        let resp = await CreateCheckpointReleaseDate({
          month: parseInt(month),
          year: parseInt(year),
          vendors: main,
        });
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSelectedIndex([]);
          getData();
        } else {
          toast.error("Error");
        }
      } else {
        toast.error("Start Date and Cutoff Date are mandatory");
      }
    } catch (error) {
      toast.error("Error");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(30);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        date: dates,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange Section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeDate = (
    date: string,
    name: string,
    ind: number,
    id: string
  ) => {
    handleAddCheckbox(id);
    if (date) {
      let date1 = moment(date).format("YYYY-MM-DD");
      setList(
        list.map((x: object, index: number) => {
          if (index !== ind) return x;
          return {
            ...x,
            [name]: date1,
          };
        })
      );
    }
  };

  const handleCopyData = (date: string, name: string) => {
    handleChangeAllVendor("true");
    if (date) {
      let date1 = moment(date).format("YYYY-MM-DD");
      setList(
        list.map((x: object, index: number) => {
          if (index === 0) return x;
          return {
            ...x,
            [name]: date1,
          };
        })
      );
    }
  };

  const [all, setAll] = useState("false");
  const handleChangeAllVendor = (value: string) => {
    setAll(value);
    if (value === "true") {
      let vendors = list.map((item: object) => getValue(item, `main_id`, ""));
      setSelectedIndex(vendors);
    } else {
      setSelectedIndex([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Checkbox Section                             */
  /* -------------------------------------------------------------------------- */

  const [selectedIndex, setSelectedIndex] = useState<any>([]);

  const handleChangeCheckbox = (id: String) => {
    let selected = selectedIndex.filter((item: string) => item === id);
    if (getValue(selected, `length`, 0) === 0) {
      selectedIndex.push(id);
      setSelectedIndex([...selectedIndex]);
    } else {
      let selected = selectedIndex.filter((item: string) => item !== id);
      setSelectedIndex(selected);
    }
  };
  const handleAddCheckbox = (id: String) => {
    let selected = selectedIndex.filter((item: string) => item === id);
    if (getValue(selected, `length`, 0) === 0) {
      selectedIndex.push(id);
      setSelectedIndex([...selectedIndex]);
    }
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const tomorrowDate: any = moment().add(1, "days");
  let tomorrow: any = new Date(tomorrowDate);

  const handleChangeExtension = (index: number, status: boolean) => {
    setList(
      list.map((x: any, i: number) => {
        if (index !== i) return x;
        return {
          ...x,
          is_extension: status,
        };
      })
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                               Audit Complete Section                       */
  /* -------------------------------------------------------------------------- */

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmModal = () => {
    setConfirmOpen(!confirmOpen);
  };
  const handleAuditCompleteConfirm = () => {
    handleConfirmModal();
  };

  const handleAuditComplete = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let month = params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM");
    let year = params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY");
    const payload = list.filter((f: object) =>
      selectedIndex.some((d: string) => d == getValue(f, `main_id`, ""))
    );

    let payloadObj = JSON.parse(JSON.stringify(payload));
    let main = payloadObj.map((item: object) => ({
      // start_date: getValue(item, `start_date`, ""),
      // cutoff_date: getValue(item, `cutoff_date`, ""),
      // is_extension: getValue(item, `is_extension`, false),
      // vendor_name: getValue(item, `vendor_name`, ""),
      is_completed: true,
      id: getValue(item, `id`, ""),
      vendor_id: getValue(item, `vendor_id`, ""),
    }));

    main.filter((item: any) => {
      if (!getValue(item, `id`, "")) {
        delete item.id;
      }
    });
    let submit = true;

    for (let i = 0; i < main.length; i++) {
      if (!main[i].cutoff_date || !main[i].start_date) {
        submit = false;
        break;
      }
    }
    try {
      let payload = {
        month: parseInt(month),
        year: parseInt(year),
        vendors: main,
      };
      let resp = await ReleaseDateAuditCompleted(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        getData();
        handleConfirmModal();
        setSelectedIndex([]);
      }
    } catch (error) {}
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "repository_checkpoint_release_date"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {selectedIndex.length > 0 && (
            <CustomNavigationBar
              selectedIndex={selectedIndex}
              handleSubmit={handleSubmit}
              permissions={props.permissions}
              handleAuditCompleteConfirm={handleAuditCompleteConfirm}
            />
          )}
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            <h4 className="dashbaord-wrapper__header-title">Release Dates</h4>
            <div className="d-flex justify-content-center align-items-center">
              {/* <DatePicker
								onChange={setDate}
								value={date}
								format="MMM yyyy"
								disableCalendar={true}
								yearAriaLabel={"yyyy"}
							/>
							<button className="header-btn" onClick={handleSubmitDate}>
								Apply
							</button> */}
              <CalenderDropdown
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                isApplyButtonRequied={true}
                isYear={true}
              />
              <NavLink to={`/repository/checkpoint/release-dates-new`} className="calender-button ms-2">V2</NavLink>
            </div>
          </div>
          
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuRepositorySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Checkpoint
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Release Dates - {moment(date || new Date()).format("MMMM YYYY")}
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                monthYear={true}
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}

                //Line Seperator of button
                lineSeperator={false}
              />
              {/* <NavLink to={`/repository/checkpoint/release-dates-new`} className="calender-button ms-2" style={{ height: "32px"}} >V2</NavLink> */}
            </div>
          </div>
          
          <div className={`main-page-layout-wrapper`} id={selectedIndex.length > 0
					? "blueNavigationVisibleReleaseDate"
					: ""}>
            <div className="admin-wrapper position-relative">
              {/* <div className="admin-wrapper position-relative">
                <SearchHeader
                  route={"/support/details"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={false}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  isFilterVisible={isFilterVisible}
                  add={"false"}
                />
              </div> */}
            
              <div className="release-date-wrapper bg-white">
                <div className="release-date-wrapper__vendor-details">
                  <div className="release-date-wrapper__header d-flex align-items-center justify-content-between">
                    <div className="release-date-wrapper__vendor-details-form d-flex align-items-center">
                      <div className="uploaded-details-wrapper-form-group form-group mr-1 mb-0">
                        <label
                          className="m-0 position-relative"
                          htmlFor="header-checkbox"
                        >
                          <input
                            type="checkbox"
                            className="default-checkbox"
                            id="header-checkbox"
                            onChange={() =>
                              handleChangeAllVendor(
                                all === "true" ? "false" : "true"
                              )
                            }
                            checked={
                              list.length === selectedIndex.length || all === "true"
                            }
                          />
                          <div className="custom-checkbox">
                            <img
                              src="/images/uploaded-details/tick.svg"
                              className="img-fluid uploaded-tick"
                            />
                          </div>
                        </label>
                      </div>
                      <h3 className="release-date-wrapper__vendor-title ">
                        Vendor Name
                      </h3>
                    </div>
                    <div className="release-date-wrapper__heading">
                      <h3 className="release-date-wrapper__vendor-title">
                        Extension
                      </h3>
                    </div>
                    <div className="release-date-wrapper__heading">
                      <h3 className="release-date-wrapper__vendor-title">
                        Start Date
                      </h3>
                    </div>
                    <div className="release-date-wrapper__heading">
                      <h3 className="release-date-wrapper__vendor-title">
                        Cutoff Date
                      </h3>
                    </div>
                  </div>
                  <div className="release-date-wrapper__active-wrapper d-flex justify-content-end">
                    <div className="release-date-wrapper__active">
                      <h5 className="release-date-wrapper__vendor-title release-date-wrapper__vendor-title--primary">
                        Active From Date & Time
                      </h5>
                      <div className="release-date-wrapper__active_details d-flex align-items-center">
                        <div className="uploaded-details-wrapper-form-group form-group mb-0">
                          <label
                            className="m-0 position-relative"
                            htmlFor="header-checkbox-start"
                          >
                            <input
                              type="checkbox"
                              className="default-checkbox"
                              id="header-checkbox-start"
                              onChange={() =>
                                handleCopyData(
                                  getValue(list, `[${0}].start_date`, ""),
                                  "start_date"
                                )
                              }
                            />
                            <div className="custom-checkbox">
                              <img
                                src="/images/uploaded-details/tick.svg"
                                className="img-fluid uploaded-tick"
                              />
                            </div>
                          </label>
                        </div>
                        <p className="release-date-wrapper__active-text">
                          Copy to All
                        </p>
                      </div>
                    </div>
                    <div className="release-date-wrapper__active">
                      <h5 className="release-date-wrapper__vendor-title release-date-wrapper__vendor-title--primary">
                        Active From Date & Time
                      </h5>
                      <div className="release-date-wrapper__active_details d-flex align-items-center">
                        <div className="uploaded-details-wrapper-form-group form-group mr-1 mb-0">
                          <label
                            className="m-0 position-relative"
                            htmlFor="header-checkbox-cutoff"
                          >
                            <input
                              type="checkbox"
                              className="default-checkbox"
                              id="header-checkbox-cutoff"
                              onChange={() =>
                                handleCopyData(
                                  getValue(list, `[${0}].cutoff_date`, ""),
                                  "cutoff_date"
                                )
                              }
                            />
                            <div className="custom-checkbox">
                              <img
                                src="/images/uploaded-details/tick.svg"
                                className="img-fluid uploaded-tick"
                              />
                            </div>
                          </label>
                        </div>
                        <p className="release-date-wrapper__active-text">
                          Copy to All
                        </p>
                      </div>
                    </div>
                  </div>
                  {isLoading || !props.permissionAPITriggered ? (
                    <Loader />
                  ) : getValue(list, `length`, 0) > 0 ? (
                    list.map((vendorObj: object, index: number) => {
                      var date = params.date ? new Date(params.date) : new Date(),
                        y = date.getFullYear(),
                        m = date.getMonth();
                      var firstDay = new Date(y, m, 1);
                      var lastDay = new Date(y, m + 1, 0);
                      return (
                        <div
                          className="release-date-wrapper__details d-flex justify-content-between"
                          key={index}
                        >
                          <div className="release-date-wrapper__vendor-details-form release-date-wrapper__vendor-details-form--details release-date-wrapper__vendor-details-form--border d-flex align-items-center">
                            <div className="uploaded-details-wrapper-form-group form-group mr-1 mb-0">
                              <label
                                className="m-0 position-relative"
                                htmlFor={`index${index}`}
                              >
                                <input
                                  type="checkbox"
                                  className="default-checkbox"
                                  id={`index${index}`}
                                  checked={selectedIndex.includes(
                                    getValue(vendorObj, `main_id`, "")
                                  )}
                                  onChange={() =>
                                    handleChangeCheckbox(
                                      getValue(vendorObj, `main_id`, "")
                                    )
                                  }
                                />
                                <div className="custom-checkbox">
                                  <img
                                    src="/images/uploaded-details/tick.svg"
                                    className="img-fluid uploaded-tick"
                                  />
                                </div>
                              </label>
                            </div>
                            <div>
                              <h3 className="release-date-wrapper__vendor-title release-date-wrapper__vendor-title--details">
                                {getValue(vendorObj, `vendor_name`, "")}
                              </h3>
                              {getValue(vendorObj, `is_audit_completed`, false) && (
                                <div className="d-flex align-items-center mt-1">
                                  <img
                                  src="/images/verified.svg"
                                  className=""
                                  height={14}
                                  width={14}
                                />
                                <p className="audit_text">
                                
                                  {getValue(vendorObj, `is_audit_completed`, false)
                                    ? "Audit Completed"
                                    : null}
                                </p>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="form-group cursor-pointer ">
                            {/* <label className="release-date-wrapper__vendor-label">
                              Start Date
                            </label> */}

                            <div className="position-relative">
                              <label
                                className="m-0 position-relative"
                                htmlFor={`index1${index}`}
                              >
                                <input
                                  type="checkbox"
                                  className="default-checkbox"
                                  id={`index1${index}`}
                                  checked={getValue(vendorObj, `is_extension`, "")}
                                  onChange={() =>
                                    handleChangeExtension(
                                      index,
                                      !getValue(vendorObj, `is_extension`, "")
                                    )
                                  }
                                />
                                <div className="custom-checkbox">
                                  <img
                                    src="/images/uploaded-details/tick.svg"
                                    className="img-fluid uploaded-tick"
                                  />
                                </div>
                              </label>
                            </div>
                          </div>
                          <div className="form-group cursor-pointer">
                            <label className="release-date-wrapper__vendor-label">
                              Start Date
                            </label>

                            <div className="position-relative">
                              <label onClick={(e) => e.preventDefault()}>
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="release-date-wrapper__vendor-form-control form-control release-date-wrapper__vendor-form-control--calendar"
                                  value={
                                    getValue(vendorObj, `start_date`, "")
                                      ? new Date(
                                          getValue(vendorObj, `start_date`, "")
                                        )
                                      : null
                                  }
                                  placeholderText="Start Date"
                                  onChange={(event: any) =>
                                    handleChangeDate(
                                      event,
                                      "start_date",
                                      index,
                                      getValue(vendorObj, `main_id`, "")
                                    )
                                  }
                                  // minDate={tomorrow}
                                  minDate={new Date()}
                                  // maxDate={lastDay}
                                />
                                <img
                                  src="/images/checkpoint/calender.svg"
                                  className="img-fluid form-image form-image--calender"
                                />
                              </label>
                            </div>
                          </div>
                          <div className="form-group cursor-pointer">
                            <label className="release-date-wrapper__vendor-label">
                              Cutoff Date
                            </label>
                            <label onClick={(e) => e.preventDefault()}>
                              <div className="position-relative">
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="release-date-wrapper__vendor-form-control form-control"
                                  value={
                                    getValue(vendorObj, `cutoff_date`, "")
                                      ? new Date(
                                          getValue(vendorObj, `cutoff_date`, "")
                                        )
                                      : null
                                  }
                                  placeholderText="Cuttoff Date"
                                  onChange={(event: any) =>
                                    handleChangeDate(
                                      event,
                                      "cutoff_date",
                                      index,
                                      getValue(vendorObj, `main_id`, "")
                                    )
                                  }
                                  minDate={
                                    new Date(getValue(vendorObj, `start_date`, ""))
                                  }
                                  // maxDate={lastDay}
                                />
                                <img
                                  src="/images/checkpoint/calender.svg"
                                  className="img-fluid form-image form-image--calender"
                                />
                              </div>
                            </label>
                          </div>
                          {/* <button
                        onClick={() =>
                          handleSubmit({
                            start_date: getValue(vendorObj, `start_date`, ""),
                            cutoff_date: getValue(vendorObj, `cutoff_date`, ""),
                            vendor_id: getValue(vendorObj, `id`, ""),
                          })
                        }
                      >
                        Submit
                      </button> */}
                        </div>
                      );
                    })
                  ) : (
                    <>
                      {Object.keys(params).length !== 0 ? (
                        <>
                          <CheckpointReleaseDatesNotfound />
                        </>
                      ) : (
                        <CheckpointReleaseDatesNotfound />
                      )}
                    </>
                  )}
                </div>
                <div className="footer-wrapper d-flex justify-content-between">
                  {list.length > 0 && (
                    <img
                      src="/images/building-illustration.svg"
                      className="img-fluid"
                    />
                  )}
                  {totalCount > 30 ? (
                    <PaginationPage
                      totalCount={totalCount}
                      limit={limit}
                      pageNumber={page_no}
                      handleChangePagination={handleChangePagination}
                      handleChangeLimit={handleChangeLimit}
                    />
                  ) : (
                    <p className="show-rows-count mt-3 d-flex">
                      Total Count:&nbsp;&nbsp;{" "}
                      <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <ConfirmModal
        isOpen={confirmOpen}
        handleModal={handleConfirmModal}
        handleSubmit={handleAuditComplete}
      />
    </DashboardLayout>
  );
}
